import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'
@Injectable({
	providedIn: 'root',
})
export class AdresseService {
	constructor(private http: HttpClient) { }

	codepostal(zipCode: string): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.adresse:codepostal',
			params: {
				zip: zipCode,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	villes(ville: string): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.adresse:villes',
			params: {
				ville: ville.toUpperCase(),
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	villebycp(zipCode: string): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.adresse:villebycp',
			params: {
				zip: zipCode,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	rues(libelle: string, villeId: any): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.adresse:rues',
			params: {
				libelle: libelle,
				villeid: villeId,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	ruebyville(villeId: any): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.adresse:ruebyville',
			params: {
				villeid: villeId,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	zone(villeId: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.adresse:zone',
			params: {
				villeid: villeId,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	zones(villeId: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.adresse:zones',
			params: {
				villeid: villeId,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	villebyid(villeId: string): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.adresse:villebyid',
			params: {
				villeId: villeId,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
}
